export default "__VITE_PUBLIC_ASSET__26fe5fca__"